import styled from 'styled-components';
import tw from 'twin.macro';

export const CastsStyled = styled.div`
  ${tw`mr-5`}
  max-width: 856px;

  h2 {
    ${tw`text-white text-3xl font-bold mb-6 my-6`}
    font-size: 32px;
  }
`;

export const CastStyled = styled.div`
  ${tw`flex `}

  .cast-image {
    ${tw`w-20 h-20 rounded-full bg-gray-200 rounded-full bg-cover`}
    /* background-image: url('/assets/images/image-generic-profile.jpg'); */
    object-fit: cover;
  }

  .cast-details {
    ${tw`flex flex-col justify-center pl-6`}

    h4 {
      ${tw`text-white font-bold`}
    }
  }
`;
